import React from 'react';
import useEventStore from '../stores/eventStore';
import { countOnlineParticipants, isParticipantOnline } from '../utils/presence';

export default function ParticipantsList({ defaultCollapsed = true }) {
  const participants = useEventStore(state => state.eventData?.participants || []);
  const hostId = useEventStore(state => state.eventData?.hostId || null);
  const presenceByUid = useEventStore(state => state.presenceByUid || {});
  const onlineCount = countOnlineParticipants(participants, presenceByUid);
  const [expanded, setExpanded] = React.useState(!defaultCollapsed);
  const panelId = 'party-participants-panel';

  return (
    <div className="bg-black/20 backdrop-blur-lg rounded-lg p-4">
      <button
        type="button"
        className="flex w-full items-center justify-between gap-3 text-left"
        aria-expanded={expanded}
        aria-controls={panelId}
        onClick={() => setExpanded((value) => !value)}
      >
        <h3 className="text-white font-medium">
          Participants ({participants.length}) · {onlineCount} online
        </h3>
        <span aria-hidden="true" className="text-white/70">{expanded ? '▴' : '▾'}</span>
      </button>

      {expanded && (
        <div id={panelId} className="mt-4 space-y-2">
          {participants.map((participant) => {
            const isHost = Boolean(hostId) && participant.id === hostId;
            const displayName = participant.name || 'Guest';
            const online = isParticipantOnline(participant.id, presenceByUid);

            return (
              <div
                key={participant.id}
                className="flex items-center justify-between p-2 rounded-lg bg-white/5 hover:bg-white/10 transition-colors"
              >
                <div className="flex items-center gap-3 min-w-0">
                  {participant.photoURL ? (
                    <img
                      src={participant.photoURL}
                      alt=""
                      className="w-8 h-8 rounded-full object-cover shrink-0"
                    />
                  ) : (
                    <div className="w-8 h-8 shrink-0 rounded-full bg-gradient-to-br from-green-500 to-indigo-500 flex items-center justify-center">
                      <span className="text-white font-medium text-sm">
                        {displayName.charAt(0).toUpperCase()}
                      </span>
                    </div>
                  )}
                  <div className="flex flex-col min-w-0">
                    <span className="text-white text-sm font-medium truncate">{displayName}</span>
                  </div>
                </div>
                <div className="flex items-center gap-2 shrink-0">
                  {isHost ? (
                    <div className="px-2 py-0.5 rounded-full bg-purple-500/20 border border-purple-500/30">
                      <span className="text-purple-300 text-xs font-medium">Host</span>
                    </div>
                  ) : (
                    <div className="px-2 py-0.5 rounded-full bg-red-500/20 border border-red-500/30">
                      <span className="text-purple-300 text-xs font-medium">Guest</span>
                    </div>
                  )}
                  {online ? (
                    <div
                      className="w-2 h-2 rounded-full bg-green-400 animate-pulse"
                      aria-label={`${displayName} is online`}
                    />
                  ) : (
                    <span className="text-xs text-gray-400">offline</span>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
